import { QueueSortOrder, QueueSortType } from '../models/graphql';

export type LibrarySortType = Record<
  string,
  {
    label: string;
    type: QueueSortType;
    order: QueueSortOrder;
  }
>;

export const LibrarySort: LibrarySortType = {
  LATEST: {
    label: 'Creation Date (newest)',
    type: QueueSortType.ORIGINAL_POST_CREATED_TIME,
    order: QueueSortOrder.DESCENDING
  },
  OLDEST: {
    label: 'Creation Date (oldest)',
    type: QueueSortType.ORIGINAL_POST_CREATED_TIME,
    order: QueueSortOrder.ASCENDING
  },
  MOST_PUBLISHED: {
    label: 'Most Published',
    type: QueueSortType.COUNT_ITERATIONS_PUBLISHED,
    order: QueueSortOrder.DESCENDING
  },
  LEAST_PUBLISHED: {
    label: 'Least Published',
    type: QueueSortType.COUNT_ITERATIONS_PUBLISHED,
    order: QueueSortOrder.ASCENDING
  },
  MOST_ENGAGING: {
    label: 'Most Engaging',
    type: QueueSortType.SUM_ITERATIONS_ENGAGEMENT,
    order: QueueSortOrder.DESCENDING
  },
  LEAST_ENGAGING: {
    label: 'Least Engaging',
    type: QueueSortType.SUM_ITERATIONS_ENGAGEMENT,
    order: QueueSortOrder.ASCENDING
  }
};

export enum PaginationEnum {
  CURSOR = 'cursorPagination',
  DATE = 'dateRangePagination'
}

export enum PostQueueErrorEnum {
  WORKSPACE_PAUSED = 'WORKSPACE_PAUSED',
  SOCIAL_PROFILE_CATEGORY_PAUSED = 'SOCIAL_PROFILE_CATEGORY_PAUSED',
  CATEGORY_SEASONALLY_PAUSED = 'CATEGORY_SEASONALLY_PAUSED',
  STATUS_UNQUEUED = 'STATUS_UNQUEUED',
  ERROR = 'ERROR'
}
